import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { Link } from "react-router-dom";
import Table, { TableBody, TableCell, TableRow } from "material-ui/Table";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

import Wrapper from "../../common/Wrapper";
import Header from "../../common/Header";
import NotificationBar from "../../Parts/NotificationBar.jsx";
import Loader from "../../Parts/Loader";
import ArrowLeft from "../../Icons/ArrowLeft";
import Syncing from "../../Icons/Syncing";
import SalesforceSyncHistoryTable from "./common/SalesforceSyncHistoryTable";

import ConfirmRevokeDialog from "./dialogs/ConfirmRevokeDialog";
import PromotePlanChangeDialog from '../../common/PromotePlanChangeDialog';
import { getLastUpdateText } from "../../../utils/utils";
import { isIntegrateSalesforceTimelineStatus } from "../../../utils/userOptionUtils";
import { SalesforceSettingDirectory, PromotePlanDialogTypes } from "../../../constants/ComponentTypes";
import { SALESFORCE_SYNC_HISTORIES_PER_PAGE } from "../../../constants/Constants.js";

const styles = () => ({
  root: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    flexWrap: "nowrap",
    alignItems: "flex-start",
  },

  content: {
    background: "#F4F6F9",
    flex: 1,
    width: "100%",
    position: "relative",
    overflow: "scroll",
  },

  progressbar: {
    marginTop: "22px",
    width: "100%",
    display: "flex",
    justifyContent: "center",
  },

  returnBtn: {
    padding: "8px 15px",
    fontSize: "13px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
  },

  overview: {
    background: "#F4F6F9",
    flex: 1,
    width: "80%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    position: "relative",
    overflow: "hidden",
    maxWidth: "1200px",
    margin: "auto",
    padding: "20px",
    boxSizing: "border-box",
  },

  body: {
    width: "100%",
    margin: "0px 0px 90px 0px",
  },

  box: {
    width: "100%",
    background: "#FFFFFF",
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    opacity: 1,
    padding: "40px 44px",
    boxSizing: "border-box",
    marginTop: "25px",
    position: "relative",
    minHeight: "200px",
  },

  heading: {
    width: "100%",
    marginTop: "14px",
  },

  title: {
    fontSize: "24px",
    fontWeight: "bold",
    marginBottom: "12px",
  },

  desc: {
    fontSize: "14px",
    marginTop: "5px",
  },

  notification: {
    marginTop: '25px',
    color: '#71737B',
    border: '1px solid #D8DBDF',
    background: '#ECEEF0',
    borderRadius: '2px',
    padding: '20px',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    fontSize: '13px',
    fontWeight: 'bold',
  },

  section: {
    borderBottom: "1px solid #E7E9EB",
    paddingBottom: "40px",
    marginBottom: "40px",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "36px",
  },

  row: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  row2: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginBottom: "24px",
  },

  syncButton: {
    border: "1px solid #E7E9EB",
    borderRadius: "2px",
    color: "#181819",
    fontSize: "11px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
    padding: "4px 7px",
    height: "25px",
    width: "55px",
    whiteSpace: "nowrap",
  },

  deleteButton: {
    border: "1px solid #FF606C",
    borderRadius: "2px",
    color: "#FF606C",
    fontSize: "15px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
    padding: "9px 20px",
  },

  disableDeleteButton: {
    border: "1px solid #D8DBDF",
    background: "#F4F6F9",
    borderRadius: "2px",
    color: "#B1B3B9",
    fontSize: "15px",
    minWidth: "unset",
    minHeight: "unset",
    justifyContent: "center",
    alignItems: "center",
    padding: "9px 20px",
  },

  link: {
    color: "#1A65FF",
    textDecoration: "none",
  },

  table: {
    width: "100%",
  },

  firstCol: {
    width: "30%",
    fontSize: "15px",
    padding: "30px 10px",
  },

  secondCol: {
    width: "60%",
    fontSize: "15px",
    padding: "30px 10px",
  },

  thirdCol: {
    width: "10%",
    fontSize: "15px",
    padding: "30px 10px",
  },

  editButton: {
    border: "1px solid #D8DBDF",
    fontSize: "11px",
    minWidth: "54px",
    color: "#181819",
    padding: "10px 15px",
  },

  subsectionHead: {
    width: "100%",
    padding: "20px 0px",
    borderBottom: "1px solid #E7E9EB",
  },

  subsectionHeadTitle: {
    fontSize: "15px",
    fontWeight: "bold",
  },

  syncHistoryContainer: {
    marginBottom: "30px",
    width: "100%",
  },
});

class SalesforceSetting extends React.Component {
  state = {
    showConfirmRevokeDialog: false,
    showNotification: false,
    message: "",
    messageType: "success",
    [PromotePlanDialogTypes.SALESFORCE_TIMELINE_STATUS.flag]: false,
  };

  componentWillMount() {
    this.props.getSalesforceUserinfo();
    this.props.getSalesforceConfig();
    this.props.getSalesforceSyncLastUpdate(); // TODO コンソール412エラーがでるので、バックエンドと合わせて修正するか、userがsalesforce連携してるかどうかの有無でAPIを実行するようにする
    this.props.getUserInfo();
    this.props.getSalesforceImportHistories({
      paging: 1,
      per_page: SALESFORCE_SYNC_HISTORIES_PER_PAGE,
      page: 1,
    });
    this.props.getSalesforceExportHistories({
      paging: 1,
      per_page: SALESFORCE_SYNC_HISTORIES_PER_PAGE,
      page: 1,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.successMessage && nextProps.successMessage !== "") {
      this.displayNotification(nextProps.successMessage, "success");
    } else if (nextProps.errorMessage && nextProps.errorMessage !== "") {
      this.displayNotification(nextProps.errorMessage, "error");
    } else if (nextProps.shortMessage && nextProps.shortMessage !== "") {
      this.displayNotification(nextProps.shortMessage, "green");
    }

    if (this.props.isRevoking && !nextProps.isRevoking && !nextProps.errorMessage) {
      this.props.goTo("/setting/integrations");
    }
  }

  componentDidUpdate(prevProps) {
    // ジョブ実行後でリロードされた場合を考慮し、ユーザー情報が取得でき次第、接続・再接続する
    if (this.props.user && !prevProps.user) {
      this.props.jobCompleted(this.props.user.id);
    }

    if (!this.props.isJobCompletedLoading && prevProps.isJobCompletedLoading) {
      this.props.getSalesforceSyncLastUpdate();
    }
  }

  /*** toggle functions ***/
  displayNotification = (message, type) => {
    this.setState({
      showNotification: true,
      message: message,
      messageType: type,
    });
  };

  toggleConfirmRevokeDialog = () => {
    this.setState({
      showConfirmRevokeDialog: !this.state.showConfirmRevokeDialog,
    });
  };

  togglePromotePlanChangeDialog = (type) => {
    this.setState({
      [type["flag"]]: !(this.state[type["flag"]])
    });
  }

  handleSync = () => {
    const { address_import_mappings_flag, exe_export_mappings_flag } =
      this.props;

    if (address_import_mappings_flag || exe_export_mappings_flag) {
      this.props.initializeMessage()
      this.props.postSalesforceSync();
    } else {
      this.displayNotification(
        "Salesforce連携機能を利用するには、自社リストとキーマンデータベースの少なくとも一方を設定してください。",
        "error"
      );
    }
  };

  /*** handlers ***/

  /*** render functions ***/
  renderConfirmRevokeDialog = () => (
    <ConfirmRevokeDialog
      action={this.props.postSalesforceRevoke}
      toggleDialog={this.toggleConfirmRevokeDialog}
      isOpen={this.state.showConfirmRevokeDialog}
      isLoading={this.props.isRevoking}
      buttonText="連携を解除"
      goTo={this.props.goTo}
    />
  );

  renderNotification = () => {
    return (
      <div
        style={{
          position: "fixed",
          zIndex: 10000,
          top: 10,
          width: "98%",
          left: "1%",
        }}
      >
        <NotificationBar
          message={this.state.message}
          type={this.state.messageType}
          open={this.state.showNotification}
          onHandleClose={() => {
            this.setState({ showNotification: false });
          }}
          autoClose={false}
          style={{
            width: this.state.messageType === "green" ? "fit-content" : "100%",
          }}
        ></NotificationBar>
      </div>
    );
  };

  renderIntegrationSettingRow = (directory, flag, isEnable = true) => {
    const { classes } = this.props;
    return (
      <TableRow className={classes.tableRow}>
        <TableCell className={classes.firstCol}>{directory.text}</TableCell>
        <TableCell
          className={classes.secondCol}
          style={{ color: flag ? "#3D8D5F" : "#5A5B62" }}
        >
          {flag ? "設定済み" : "未設定"}
        </TableCell>
        <TableCell className={classes.thirdCol}>
          <Button
            color="primary"
            className={classes.editButton}
            onClick={() => {
              if (isEnable) {
                if (flag) {
                  this.props.goTo(directory.setting_path);
                } else {
                  this.props.goTo(directory.setup_path);
                }
              } else {
                this.togglePromotePlanChangeDialog(PromotePlanDialogTypes.SALESFORCE_TIMELINE_STATUS)
              }
            }}
          >
            {flag ? "詳細" : "設定"}
          </Button>
        </TableCell>
      </TableRow>
    );
  };

  renderSubsectionHead = (title) => {
    const { classes } = this.props;
    return (
      <div className={classes.subsectionHead}>
        <Typography variant="title" className={classes.subsectionHeadTitle}>
          {title}
        </Typography>
      </div>
    );
  };

  renderPromotePlanChangeDialog = (type) => {
    return (
      <PromotePlanChangeDialog
        isOpen={this.state[type["flag"]]}
        type={type}
        toggleDialog={() => this.togglePromotePlanChangeDialog(type)}
        handlePlanChange={this.togglePlanDialog}
      />
    );
  };

  render() {
    const {
      classes,
      salesforceUserName,
      lastUpdate,
      address_import_mappings_flag,
      exe_export_mappings_flag,
      timeline_status_export_mappings_flag,
    } = this.props;

    let notification, confirmRevokeDialog;
    if (this.state.showNotification) {
      notification = this.renderNotification();
    }
    if (this.state.showConfirmRevokeDialog) {
      confirmRevokeDialog = this.renderConfirmRevokeDialog();
    }

    return (
      <Wrapper className={classes.root}>
        <Header title="Salesforce連携設定" type="dark" hasBackBtn={false} />
        <div className={classes.content}>
          <div className={classes.overview}>
            <div
              className={classes.progressbar}
              style={{ justifyContent: "flex-start" }}
            >
              <Button
                className={classes.returnBtn}
                onClick={() => this.props.goTo("/setting/integrations")}
              >
                <ArrowLeft
                  color="#71737B"
                  width={14}
                  height={14}
                  style={{ marginRight: "6px" }}
                />
                <span>戻る</span>
              </Button>
            </div>
            <div className={classes.heading}>
              <Typography variant="title" className={classes.title}>
                Salesforce連携設定
              </Typography>
              <Typography variant="body2" className={classes.desc}>
                Salesforce連携機能を利用すると、SalesforceリストをKeyman
                Letterに同期して、Salesforceのレコードにレターを送付し、送付状況とQRコードへのリアクションを、Salesforce上で確認できます。また、当社のキーマンデータベースをSalesforceに同期することも可能です。
              </Typography>
              <Typography variant="body2" className={classes.desc}>
                <a
                  href="/how-to/salesforce/connect-account"
                  target="_blank"
                  rel="noreferrer noopener"
                  className={classes.link}
                  style={{ textDecoration: "underline", marginRight: 30 }}
                >
                  Salesforce設定手順書
                </a>
                <a
                  href="/how-to/salesforce/operation"
                  target="_blank"
                  rel="noreferrer noopener"
                  className={classes.link}
                  style={{ textDecoration: "underline" }}
                >
                  レター送付のSalesforceの運用のイメージ
                </a>
                <a
                  href="/how-to/salesforce/duplication"
                  target="_blank"
                  rel="noreferrer noopener"
                  className={classes.link}
                  style={{ textDecoration: "underline" }}
                >
                  Salesforceとのデータの重複について
                </a>
              </Typography>
            </div>
            <div className={classes.notification}>外部システムとの連携はSalesforce Enterprise Editionのみ可能でございます。お使いになられているSalesforceとKeyman Letterとの連携可否につきましては貴社のSalesforceの管理者にご確認くださいませ。</div>
            {(() => {
              if (
                this.props.isLoadingConfig ||
                this.props.isLoadingSalesforceUserInfo
              ) {
                return (
                  <div className={classes.box}>
                    <Loader type="color" />
                  </div>
                );
              } else {
                if (!salesforceUserName) {
                  if (this.props.expiredAccessError) {
                    return (
                      <div
                        className={classes.box}
                        style={{ minHeight: "unset" }}
                      >
                        <Typography variant="subheading">
                          認証情報が失効しています。
                          <a
                            href={
                              process.env.REACT_APP_API_BASE_URL +
                              "/oauth2/salesforce?redirect_url=" +
                              process.env.REACT_APP_FRONTEND_URL +
                              "/setting/integrations/salesforce"
                            }
                            target="_self"
                            className={classes.link}
                          >
                            こちら
                          </a>
                          より再設定してください。
                        </Typography>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className={classes.box}
                        style={{ minHeight: "unset" }}
                      >
                        <Typography variant="subheading">
                          Salesforceに連携されていません。
                          <Link
                            to="/setting/integrations"
                            className={classes.link}
                          >
                            「アカウント管理＞連携」
                          </Link>
                          で設定してください。
                        </Typography>
                      </div>
                    );
                  }
                } else {
                  return (
                    <div className={classes.body}>
                      <div className={classes.box}>
                        <Typography
                          variant="title"
                          className={classes.sectionTitle}
                        >
                          連携アカウント
                        </Typography>
                        <div className={classes.row}>
                          <Typography variant="subheading">
                            {salesforceUserName ? salesforceUserName : "-"}
                          </Typography>
                          <div className={classes.row2}>
                            {(() => {
                              if (this.props.isJobCompletedLoading) {
                                return (
                                  <Typography
                                    variant="body1"
                                    style={{
                                      marginRight: "6px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    同期中…
                                  </Typography>
                                );
                              } else if (lastUpdate) {
                                return (
                                  <Typography
                                    variant="body1"
                                    style={{
                                      marginRight: "6px",
                                      fontSize: "12px",
                                    }}
                                  >
                                    最終同期：
                                    {getLastUpdateText(lastUpdate)}
                                  </Typography>
                                );
                              }
                            })()}
                            <Button
                              className={classes.syncButton}
                              onClick={this.handleSync}
                              disabled={this.props.isJobCompletedLoading}
                              style={{
                                background: this.props.isJobCompletedLoading
                                  ? "#F2F6FF"
                                  : "transparent",
                              }}
                            >
                              <Syncing
                                width={11}
                                height={11}
                                color={
                                  this.props.isJobCompletedLoading ? "#5593FF" : "#71737B"
                                }
                                style={{ display: "block" }}
                              />
                              {!this.props.isJobCompletedLoading && (
                                <span style={{ marginLeft: "6px" }}>同期</span>
                              )}
                            </Button>
                          </div>
                        </div>
                      </div>

                      <div className={classes.box}>
                        <Typography
                          variant="title"
                          className={classes.sectionTitle}
                        >
                          連携設定
                        </Typography>
                        <Table className={classes.table}>
                          <TableBody>
                            {this.renderIntegrationSettingRow(
                              SalesforceSettingDirectory.ADDRESS_BOOK,
                              address_import_mappings_flag
                            )}
                            {this.renderIntegrationSettingRow(
                              SalesforceSettingDirectory.EXE_LIST,
                              exe_export_mappings_flag
                            )}
                            {this.renderIntegrationSettingRow(
                              SalesforceSettingDirectory.TIMELINE_STATUS,
                              timeline_status_export_mappings_flag,
                              isIntegrateSalesforceTimelineStatus(this.props.user)
                            )}
                          </TableBody>
                        </Table>
                      </div>

                      <div className={classes.box}>
                        <Typography
                          variant="title"
                          className={classes.sectionTitle}
                        >
                          同期履歴
                        </Typography>
                        <div className={classes.syncHistoryContainer}>
                          {this.renderSubsectionHead("インポート履歴")}
                          <SalesforceSyncHistoryTable
                            items={this.props.salesforceImportHistories}
                            pageInfo={this.props.pageInfo_importHistories}
                            isImport={true}
                            isLoading={this.props.isLoadingImportHistories}
                            getHistories={
                              this.props.getSalesforceImportHistories
                            }
                          />
                        </div>
                        <div className={classes.syncHistoryContainer}>
                          {this.renderSubsectionHead("エクスポート履歴")}
                          <SalesforceSyncHistoryTable
                            items={this.props.salesforceExportHistories}
                            pageInfo={this.props.pageInfo_exportHistories}
                            isImport={false}
                            isLoading={this.props.isLoadingExportHistories}
                            getHistories={
                              this.props.getSalesforceExportHistories
                            }
                          />
                        </div>
                      </div>

                      <div className={classes.box}>
                        <Typography
                          variant="title"
                          className={classes.sectionTitle}
                        >
                          その他
                        </Typography>
                        <div className={classes.row}>
                          <Button
                            color="secondary"
                            className={
                              this.props.isJobCompletedLoading || this.props.isRevoking
                                ? classes.disableDeleteButton
                                : classes.deleteButton
                            }
                            onClick={this.toggleConfirmRevokeDialog}
                            disabled={
                              this.props.isJobCompletedLoading || this.props.isRevoking
                            }
                          >
                            {this.props.isRevoking
                              ? "連携を解除中..."
                              : "連携を解除"}
                          </Button>
                        </div>
                      </div>
                    </div>
                  );
                }
              }
            })()}
          </div>
        </div>
        {notification}
        {confirmRevokeDialog}
        {this.renderPromotePlanChangeDialog(PromotePlanDialogTypes.SALESFORCE_TIMELINE_STATUS)}
      </Wrapper>
    );
  }
}

SalesforceSetting.propTypes = {
  classes: PropTypes.object.isRequired,
  user: PropTypes.object,
  message: PropTypes.string,
  isSaving: PropTypes.bool,
  error: PropTypes.object,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.string,
  shortMessage: PropTypes.string,
  isJobCompletedLoading: PropTypes.bool,
  isRevoking: PropTypes.bool,
  expiredAccessError: PropTypes.bool,
  salesforceUserName: PropTypes.string,
  lastUpdate: PropTypes.string,
  address_import_mappings_flag: PropTypes.bool,
  exe_export_mappings_flag: PropTypes.bool,
  timeline_status_export_mappings_flag: PropTypes.bool,
  salesforceImportHistories: PropTypes.array,
  salesforceExportHistories: PropTypes.array,
  pageInfo_importHistories: PropTypes.object,
  pageInfo_exportHistories: PropTypes.object,
  isLoadingConfig: PropTypes.bool,
  isLoadingSalesforceUserInfo: PropTypes.bool,
  isLoadingImportHistories: PropTypes.bool,
  isLoadingExportHistories: PropTypes.bool,
  getUserInfo: PropTypes.func,
  getSalesforceUserinfo: PropTypes.func,
  getSalesforceConfig: PropTypes.func,
  initializeMessage: PropTypes.func.isRequired,
  jobCompleted: PropTypes.func.isRequired,
  getSalesforceSyncLastUpdate: PropTypes.func,
  getSalesforceImportHistories: PropTypes.func,
  getSalesforceExportHistories: PropTypes.func,
  postSalesforceSync: PropTypes.func,
  postSalesforceRevoke: PropTypes.func,
  goTo: PropTypes.func,
};

export default withStyles(styles)(SalesforceSetting);



// WEBPACK FOOTER //
// ./src/components/AccountSetting/Salesforce/SalesforceSetting.jsx